<template>
    <div class="indexCon">
        <swiperCon />
        <div class="book_con">
            <div class="banner"></div>
            <carefullyChosen />
        </div>
    </div>
</template>

<script>
import swiperCon from './indexCon/swiperCon.vue';
import carefullyChosen from './indexCon/carefullyChosen.vue';
export default {
    components: {
        carefullyChosen,
        swiperCon
    },
    data() {
        return {

        }
    },
    methods: {
        theme(theme) {
            window.document.documentElement.setAttribute("data-theme", theme);
        },
    }
}
</script>

<style lang="scss" scoped>
    .indexCon{
        width: 1200px;
        margin: 0 auto;
        >.book_con{
            width: 100%;
            overflow: hidden;
        }
    }
</style>
